module.exports = __webpack_public_path__ + "img/home.2410eae7.png";